import { put, takeEvery, call } from 'redux-saga/effects';
import Axios from 'axios';
import { message } from 'antd';
import moment from 'moment';

import Actions from '../action';
import { appConstant, apiUrl, colorsList } from '@constants';
import { setStartDate, getRandomColors, getKeyAndToken } from '@helpers';
import ActionsApp from '@sharedComponent/app-action-reducer/action';

const dateFormat = 'MM/DD/YYYY';
const thisWeekValue = {
	startDate: moment(setStartDate('THIS_WEEK')).format(dateFormat),
	endDate: moment(new Date()).format(dateFormat),
};

export function* affiliateUsageTotalVisit({ history }) {
	const { authKey, authToken } = yield getKeyAndToken();
	try {
		const uri = `${appConstant.domain + apiUrl.GET_AFFILIATE_USAGE_TOTAL_VISIT}${authKey}&startDate=${thisWeekValue.startDate}&endDate=${thisWeekValue.endDate
			}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getAffiliateUsageTotalVisitSuccess(res.data.messages));
	} catch (err) {
		let mes = appConstant.somethingWentWrong;
		message.error(mes);
		// yield put(ActionsApp.creators.removeUser(authKey, history));
		yield put(Actions.creators.getAffiliateUsageTotalVisitFail());
	}
}

export function* affiliateUsageAverageTotalVisit() {
	try {
		const { authKey, authToken } = yield getKeyAndToken();
		const uri = `${appConstant.domain + apiUrl.GET_AFFILIATE_USAGE_AVERAGE_TOTAL_VISIT}${authKey}&startDate=${thisWeekValue.startDate}&endDate=${thisWeekValue.endDate
			}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getAffiliateUsageAverageTotalVisitSuccess(res.data.messages));
	} catch (err) {
		let mes = appConstant.somethingWentWrong;
		message.error(mes);
		yield put(Actions.creators.getAffiliateUsageAverageTotalVisitFail());
	}
}

export function* affiliateUsageChartData({ request, chartType }) {
	try {
		const { authKey, authToken } = yield getKeyAndToken();
		const uri = `${appConstant.domain + apiUrl.GET_AFFILIATE_USAGE_CHART_DATA}${authKey}&startDate=${request.startDate}&endDate=${request.endDate
			}`;

		const response = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		let labels = [];
		let datasets = [];
		labels = response.data && response.data && response.data.messages.labels ? response.data.messages.labels : [];

		let labe = [];
		labels.forEach((e, index) => {
			labe[index] = moment(e).format(dateFormat);
		});

		let affiliateUsageDropdown = (response.data && response.data.messages && response.data.messages.labels) || [];

		datasets = response.data && response.data.messages && response.data.messages.chartDataSets ? response.data.messages.chartDataSets : [];
		if (response.data && response.data.messages.chartDataSets && response.data.messages.chartDataSets.length > 0) {
			datasets.map((value, i) => {
				let random = colorsList[i] || getRandomColors();

				value.type = chartType || 'line';
				value.fill = false;
				value.barPercentage = 0.3;
				value.backgroundColor = random;
				value.borderColor = random;
				value.hoverBackgroundColor = random;
				value.hoverBorderColor = random;
				// value.backgroundColor = '#0079FE';
				// value.borderColor = '#0079FE';
				// value.hoverBackgroundColor = '#0079FE';
				// value.hoverBorderColor = '#0079FE';
				value.borderWidth = 0;
				value.maxBarThickness = 15;
				value.minBarLength = 0.3;
				// value.barThickness = 5;
				value.barPercentage = 1;
				value.categoryPercentage = 0.2;
				return value;
			});
		}
		// datasets.splice(0, 3);
		// labels.splice(0, 3);
		yield put(Actions.creators.getAffiliateUsageChartdataSuccess({ labels, datasets }, affiliateUsageDropdown));
	} catch (err) {
		let mes = appConstant.somethingWentWrong;
		message.error(mes);
		yield put(Actions.creators.getAffiliateUsageChartdataFail());
	}
}

export function* affiliateUsageTableData({ request }) {
	try {
		const { authKey, authToken } = yield getKeyAndToken();
		const uri = `${appConstant.domain + apiUrl.GET_AFFILIATE_USAGE_TABLE_DATA}${authKey}&startDate=${request.startDate}&endDate=${request.endDate
			}`;
		const res = yield call(Axios.get, uri, { headers: { Authorization: authToken } });
		yield put(Actions.creators.getAffiliateUsageTabledataSuccess(res.data.messages));
	} catch (err) {
		let mes = appConstant.somethingWentWrong;
		message.error(mes);
		yield put(Actions.creators.getAffiliateUsageTabledataFail());
	}
}

export default function* affiliateWatcher() {
	yield takeEvery(Actions.types.GET_AFFILIATE_USAGE_TOTAL_VISIT_STARTED, affiliateUsageTotalVisit);
	yield takeEvery(Actions.types.GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_STARTED, affiliateUsageAverageTotalVisit);
	yield takeEvery(Actions.types.GET_AFFILIATE_CHART_DATA_STARTED, affiliateUsageChartData);
	yield takeEvery(Actions.types.GET_AFFILIATE_TABLE_DATA_STARTED, affiliateUsageTableData);
}
